export default () => {
    $('.container').on('click', '.carousel-item.video', (e) => {
        e.preventDefault();
        const embedUrl = $(e.currentTarget).data('video');

        if (embedUrl !== $('.embed-responsive-item').attr('src')) {
            $('.embed-responsive-item').attr('src', embedUrl);
        }

        $('#videoModal').modal();
    });

    $('#videoModal').on('hidden.bs.modal', () => {
        $('.embed-responsive-item').attr('src', '');
    });
};
